import { compose } from 'recompose'

import withAppContext from './withAppContext'
import withProvider from './withProvider'
import { withInitQuery } from './withInitQuery'


const withAppInit = App => compose(
	withProvider,
	withAppContext,
	withInitQuery
)(App)

export default withAppInit
